import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import React, { useEffect, useState } from "react";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useHistory, useLocation } from "react-router-dom";
import MCSLoading from "../../../components/MCSLoading";
import OrderOrganizationDetails from "../../../components/order/OrderOrganizationDetails";
import { GlobalAlertContext } from "../../../context/GlobalAlertContext";
import { adminService } from "../../../services/admin.service";
import { AdminRoutes } from "../../../_constants/PageRoutes";
import OrderInformation from "./Components/OrderInformation";
import SubscriptionInformation from "./Components/SubscriptionInformation";
import UpdateOrderForm from "./Components/UpdateOrderForm";
import { AuthContext } from "../../../context/AuthContext";

const ManageOrderDetails = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [order, setOrder] = useState(null);
  const { promiseInProgress } = usePromiseTracker();
  const [products, setProducts] = useState(null);
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [feeWaiverDetails, setFeeWaiverDetails] = useState(null);

  const fetchData = async () =>
    adminService
      .GetOrder(location.state.orderId)
      .then((res) => {
        console.log(res)
        setOrder(res.data.order);
        setProducts(res.data.productList);
        setFeeWaiverDetails(res.data.orderFeeWaiver);
        setSubscriptionDetails(res.data.subscriptionDetails);
      })

  useEffect(() => {
    if (location.state == null || location.state.orderId == null) {
      history.push(AdminRoutes.MANAGESUBSCRIPTION_ORDER);
    } else {
      trackPromise(fetchData());
    }
  }, []);

  return (
    <GlobalAlertContext.Consumer>
      {(alertObj) => (
        <AuthContext.Consumer>
          {(currentUser) => (
            <>
              <Grid>
                <Row>
                  <Col>
                    <Typography tag="h1">Order Details </Typography>
                  </Col>
                </Row>
                {promiseInProgress && <MCSLoading />}
                {!promiseInProgress && order && (
                  <>
                    <Row>
                      <Col xs={4} sm={4} md={4} lg={6}>
                        <OrderInformation order={order} />
                      </Col>
                      <Col xs={4} sm={4} md={4} lg={6}>
                        <OrderOrganizationDetails licensedBusinessPaymentInformation={order.licensedBusinessPaymentInformation}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <SubscriptionInformation
                          products={products}
                          subscriptionDetails={subscriptionDetails}
                          feeWaiverDetails={feeWaiverDetails}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <UpdateOrderForm
                          currentUser={currentUser}
                          alertObj={alertObj}
                          order={order}
                        />
                      </Col>
                    </Row>
                  </>
                )}
              </Grid>
            </>
          )}
        </AuthContext.Consumer>
      )}
    </GlobalAlertContext.Consumer>
  );
};
export default ManageOrderDetails;
